import React from 'react';
import './style.scss';

export default function TotalBox({
  itemsTotal = 0,
  totalAmount = null,
  adminFee = 0,
  paymentLabel = 'Purchase-on-Behalf',
  adminFeeText,
  discount = null,
}) {
  const feeNum = Number(adminFee || 0);

  const calculatedTotal = totalAmount !== null && totalAmount !== undefined
    ? Number(totalAmount)
    : (itemsTotal > 0 ? Number(itemsTotal) + feeNum : 0);

  const formattedTotal = `$${calculatedTotal.toFixed(2)} SGD`;
  const displayAdminFeeText = adminFeeText || `Admin fee included: $${feeNum.toFixed(2)}`;

  return (
    <div className="total-box-container">
      <div className="total-box-top">
        <div className="total-row">
          <span className="total-label">Order Total</span>
          <span className="total-amount">{formattedTotal}</span>
        </div>

        {discount && (
          <div className="discount-chip">
            <span className="discount-icon">🏷</span>
            <span className="discount-text">{discount.text}</span>
            <span className="discount-amount">{discount.amount}</span>
          </div>
        )}
      </div>

      <div className="total-box-bottom">
        <span className="payment-label">{paymentLabel}</span>
        {(feeNum > 0 || adminFeeText) && (
          <span className="admin-fee-label">{displayAdminFeeText}</span>
        )}
      </div>
    </div>
  );
}
